import React from "react";

const VideoCard = ({ videoDetails }) => {
  const { thumbnail, title, duration, description } = videoDetails;

  return (
    <div className="d-flex my-4 items-center bg-white rounded-2xl shadow-md hover:shadow-lg transition-all duration-200 border border-gray-200 p-3 w-full max-w-2xl">
      <img
        src={thumbnail}
        alt={title}
        style={{ width: "150px" }}
        className="w-15 h-15 object-cover rounded-xl mr-4"
      />

      <div className="d-flex justify-center items-start flex-grow-1 align-items-center">
        <div className="flex flex-col">
          <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
          <p className="text-sm text-gray-500 mb-1">{duration}</p>
          <p className="text-sm text-gray-600">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default VideoCard;
